import type { ComponentProps } from 'react'
import { Badge } from '@deepguide-ai/ui/badge'
import { CATEGORY_LABELS } from './type'

type BadgeStatus = ComponentProps<typeof Badge>['status']

export function CategoryLabel({ category }: { category: string }) {
  return (
    <span className='font-body border-status-blue/30 bg-status-blue-bg inline-flex items-center rounded-sm border px-2 py-0.5 text-[11px] font-medium text-status-blue-strong'>
      {CATEGORY_LABELS[category] ?? category}
    </span>
  )
}

export function ProvenanceBadge({ provider }: { provider: string }) {
  const statuses: Record<string, BadgeStatus> = {
    discovered: 'blue',
    context: 'green',
    manual: 'default',
  }
  const labels: Record<string, string> = {
    discovered: 'Discovered',
    context: 'From Context',
    manual: 'Manual',
  }
  return (
    <Badge
      status={statuses[provider] ?? 'default'}
      className='font-body h-5 rounded-full text-[10px]'
    >
      {labels[provider] ?? provider}
    </Badge>
  )
}

export function RiskTierBadge({
  tier,
  score,
}: {
  tier: string
  score?: number | null
}) {
  const statuses: Record<string, BadgeStatus> = {
    CRITICAL: 'red',
    HIGH: 'red',
    MEDIUM: 'amber',
    LOW: 'green',
  }
  return (
    <Badge
      status={statuses[tier] ?? 'default'}
      className='font-body h-5 text-[11px] tabular-nums'
      title={`${tier.charAt(0) + tier.slice(1).toLowerCase()} risk${score != null ? ` · ${score} / 100` : ''}`}
    >
      {score != null ? score : tier.charAt(0) + tier.slice(1).toLowerCase()}
    </Badge>
  )
}

export function VendorStatusBadge({ status }: { status: string }) {
  const statuses: Record<string, BadgeStatus> = {
    ACTIVE: 'green',
    UNDER_REVIEW: 'blue',
    OFFBOARDED: 'default',
    PENDING_ONBOARDING: 'amber',
  }
  const labels: Record<string, string> = {
    ACTIVE: 'Active',
    UNDER_REVIEW: 'Under Review',
    OFFBOARDED: 'Offboarded',
    PENDING_ONBOARDING: 'Pending',
  }
  return (
    <Badge
      status={statuses[status] ?? 'default'}
      className='font-body h-5 text-[11px] whitespace-nowrap'
    >
      {labels[status] ?? status}
    </Badge>
  )
}
